import { create } from 'zustand';
import { supabase } from './supabase';

export interface DomainReseller {
  id: string;
  name: string;
  discount_percent: number;
  margin_percent: number;
  default_language: string;
  brand_color: string | null;
  email: string | null;
  cart_url: string | null;
  cart_api_key_id: string | null;
  shop_url: string | null;
}

interface DomainState {
  domainReseller: DomainReseller | null;
  domainChecked: boolean;
  initialize: () => Promise<void>;
}

export const useDomainStore = create<DomainState>((set, get) => ({
  domainReseller: null,
  domainChecked: false,

  initialize: async () => {
    if (get().domainChecked) return;

    const host = window.location.hostname;

    const localhostLike = ['localhost', '127.0.0.1', '0.0.0.0'];
    if (localhostLike.includes(host) || host.endsWith('.bolt.new') || host.endsWith('.stackblitz.io') || host.endsWith('.webcontainer.io')) {
      set({ domainReseller: null, domainChecked: true });
      return;
    }

    const { data } = await supabase
      .from('resellers')
      .select('id, name, discount_percent, margin_percent, default_language, brand_color, email, cart_url, cart_api_key_id, shop_url')
      .eq('domain', host)
      .maybeSingle();

    set({ domainReseller: data ?? null, domainChecked: true });
  },
}));
